export const ListingFullPaymentOptionEnum = {
    Yes: 'yes',
    No: 'no',
    Optional: 'optional'
}